// app/javascript/lib/path_data.js
// Сериализация команд opentype.Path в атрибут d. Общий модуль для браузера
// (редактор) и node-хелпера (SVG купона) — путь обязан совпадать байт-в-байт,
// иначе превью разъедется с TIFF.
//
// Почему не opentype.Path#toPathData(2):
//   1. roundDecimal в opentype.js 2.0.0 склеивает число со строкой ("e+2"), и на
//      координате вида 249.00000000000003 (обычный итог сложения сдвигов глифов)
//      получает "2.8e-14e+2" → NaN в атрибуте d. Разбор пути на NaN обрывается —
//      и в браузере (Path2D), и в librsvg (растеризация TIFF): хвост надписи
//      просто исчезает.
//   2. Контуры не замыкаются: без Z обводка контура рисуется как открытая линия,
//      и в точке старта вместо стыка встают два торца — зазубрина на букве.

// Округление до сотых. Единицы пути — сотые доли миллиметра при 100u/мм, так что
// сотая единицы (0.0001 мм) заведомо мельче разрешения печати.
function num(v) {
  const r = Math.round(v * 100) / 100
  return Object.is(r, -0) ? "0" : String(r)
}

export function pathDataFrom(commands) {
  let d = ""
  let open = false   // начатый контур, который ещё не закрыт
  for (const c of commands) {
    switch (c.type) {
      case "M":
        if (open) d += "Z"
        d += `M${num(c.x)} ${num(c.y)}`
        open = true
        break
      case "L": d += `L${num(c.x)} ${num(c.y)}`; break
      case "Q": d += `Q${num(c.x1)} ${num(c.y1)} ${num(c.x)} ${num(c.y)}`; break
      case "C": d += `C${num(c.x1)} ${num(c.y1)} ${num(c.x2)} ${num(c.y2)} ${num(c.x)} ${num(c.y)}`; break
      case "Z": d += "Z"; open = false; break
    }
  }
  return open ? d + "Z" : d
}
